<div class="flex flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-custom
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-1 items-center justify-center w-full">
      <span class="text-shikenso-purple-base-60 font-bold text-[28px]">
        {{ 'pages.campaignDetails.ctaAnalytics.details.custom.manualAcceptRejectNote' | translate }}
      </span>
    </div>
  }
</div>
